import { CollectionMetadata as GqlItem } from '../../generated/graphql';
import { take } from '../../util';

export type CollectionMetadata = {
  currentPage: number;
  limitValue: number;
  totalCount: number;
  totalPages: number;
};

export const fromGql = (item: GqlItem): CollectionMetadata => ({
  ...(take<CollectionMetadata>(item, 'limitValue', 'totalCount', 'totalPages', 'currentPage')),
});
